import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Link,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type { PageContextPayload } from '@sections/Admin/packs/Projects/screens/Detail/screens/TaskDetail'

import type { TaskListItemModel, TaskListModel } from '@models/types'

import useTrackingLink from '@hooks/useTrackingLink'
import useTrackingLinks from '@hooks/useTrackingLinks'

import TrackingLink from './TrackingLink'

interface LinksProps {
  taskList: TaskListModel,
  taskListItem: TaskListItemModel,
}

const Links = (props: LinksProps) => {
  const { taskList, taskListItem } = props

  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteTrackingLink,
    },
  } = pageContext

  const taskTrackingLinksPayload = useTrackingLinks({
    filters: {
      recipient_type: 'TaskListItem',
      recipient_id: taskListItem.id,
    },
    performHttpRequests: !!taskListItem.id,
  })

  const { filteredTrackingLinks, hasFilteredTrackingLinks, loading } = taskTrackingLinksPayload

  // Task List Tracking Links
  const taskListTrackingLinkPayload = useTrackingLink({
    owner_id: taskList.owner_id,
    owner_type: taskList.owner_type,
    subject_id: taskList.id,
    subject_type: 'TaskList',
    recipient_id: taskList.id,
    recipient_type: 'TaskList',
  })

  const {
    callbacks: { createOrEditTrackingLink: createOrEditTaskListTrackingLink },
  } = taskListTrackingLinkPayload

  // Task Tracking Links
  const taskTrackingLinkPayload = useTrackingLink({
    owner_id: taskList.owner_id,
    owner_type: taskList.owner_type,
    subject_id: taskList.id,
    subject_type: 'TaskList',
    recipient_id: taskListItem.id,
    recipient_type: 'TaskListItem',
  })

  const {
    callbacks: { createOrEditTrackingLink: createOrEditTaskTrackingLink },
  } = taskTrackingLinkPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link onClick={() => createOrEditTaskListTrackingLink()} textProps={{ fontSize: 'small' }}>
          Project Links
        </Link>
      )}
      title="Task Links"
    >
      <Box flexDirection="column">
        {filteredTrackingLinks.map(trackingLink => (
          <TrackingLink callbacks={{ deleteTrackingLink }} key={trackingLink.id} trackingLink={trackingLink} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredTrackingLinks ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditTaskTrackingLink()}
          marginLeft="auto"
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Task Link
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Links
